module.exports = __webpack_public_path__ + "img/emptystate.829f98bc.svg";